module.exports = __webpack_public_path__ + "951a7a091a85f5276c1bed37a85c03f4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/wasistgoldencity5.jpg
// module id = 646
// module chunks = 0